import { render, staticRenderFns } from "./packageCard.vue?vue&type=template&id=6aedab48&scoped=true&"
import script from "./packageCard.vue?vue&type=script&lang=js&"
export * from "./packageCard.vue?vue&type=script&lang=js&"
import style0 from "./packageCard.vue?vue&type=style&index=0&id=6aedab48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aedab48",
  null
  
)

export default component.exports